import { useAuth, useRedirectToPage } from "../../hooks";

export const RedirectToSignUpWithInvitationCode = () => {
  const { app_rehydration_completed } = useAuth(); // prevent redirection to sign-up-with-code page while rehydrating

  useRedirectToPage("/signup-with-code", app_rehydration_completed);

  return null;
};
